// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2g8kq","cell":"ColumnAccessor_cell__bpAF6","firstCellAccent":"ColumnAccessor_firstCellAccent__3q6Im"};